<div class="search-sorting">
  <div
    class="container-fluid px-0 udex-pt-lg-32 default-search-sorting"
    data-cy="search-sorting"
  >
    <div
      class="row d-flex justify-content-center"
      data-cy="search-sorting"
    >
      <div class="col d-flex justify-content-between align-items-end">
        <dcp-search-results-title></dcp-search-results-title>
      </div>
    </div>
    <div class="row udex-mt-16">
      <div class="col d-flex justify-content-between">
        <dcp-search-facet-list></dcp-search-facet-list>
      </div>
    </div>
  </div>
</div>
